<div class="bloc-title mb-3">campaigns overview</div>
<div *ngIf="!isAdmin && !isSupplier">
    <div class="mb-2">Filter by:</div>
    <form name="form" [formGroup]="form" class="mb-4">
        <div class="row">
            <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                <mat-form-field class="form-group dark-input">
                    <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                        (input)="filterChange('filterValues')" />
                </mat-form-field>
            </div>
            <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                <mat-form-field class="form-group dark-input">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status" (selectionChange)="filterChange('filterValues')"
                        panelClass="select-panel-down" [disableOptionCentering]="true">
                        <mat-option *ngFor="let status of status | keyvalue" [value]="status.value.value"
                            class="text-capitalize">
                            <span>{{ status.value.label }}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                <mat-form-field class="form-group dark-input">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startDatePicker" formControlName="startDate"
                        (dateChange)="filterChange('filterValues')" />
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                <mat-form-field class="form-group dark-input">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
                        (dateChange)="filterChange('filterValues')" />
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                <button mat-flat-button color="warn" (click)="resetFilters(form, 'filterValues')">
                    Reset
                </button>
            </div>
        </div>
    </form>
    <div>
        <div class="mat-elevation-z8">
            <div class="tableHolder table-responsive">
                <table mat-table [dataSource]="dataSource.dataSource" class="table" matSort
                    (matSortChange)="getUserCampaigns($event)" matSortDirection="asc">
                    <!-- campaign_name -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.title }}
                        </td>
                    </ng-container>

                    <!-- start_date -->
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.startDate | date: 'medium' }}
                        </td>
                    </ng-container>

                    <!-- end_date -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.endDate | date: 'medium' }}
                        </td>
                    </ng-container>

                    <!-- status -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                    'background-color': this.status[element.status].color
                                }">
                                {{ this.status[element.status].label }}
                                <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                        buildUpcomingStatusMessage(
                                            element.upcomingStatusDate,
                                            element.upcomingStatus
                                        )
                                    " style="background: transparent; cursor: pointer; padding: 4px">
                                    *
                                </span>
                                <span *ngIf="
                                        element.status == campaignStatus.PAUSED_PENDING_SUP_APPROVALS ||
                                        shouldShowStartsIn2WorkingDaysToolTip(element)
                                    " [matTooltip]="buildInfoMessagePerStatus(element.status)"
                                    style="background: transparent; cursor: pointer; padding: 4px">
                                    *
                                </span>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.campaignTotalPrice != null">{{
                                element.campaignTotalPrice.value
                                | currency: element.campaignTotalPrice.currencyCode
                                }}</span>
                            <span *ngIf="element.campaignTotalPrice == null">0</span>
                        </td>
                    </ng-container>

                    <!-- actions -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSource"
                                (onTriggerAction)="handleAction($event)">
                            </app-campaign-action-buttons>
                        </td>
                    </ng-container>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="9999" style="text-align: center">
                            No data matching the filter
                        </td>
                    </tr>

                    <tr mat-header-row *matHeaderRowDef="clientColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: clientColumns"
                        [class.unseen-update]="row.hasUnseenUpdates"></tr>
                </table>
                <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                    showFirstLastButtons
                    (page)="getUserCampaigns(userSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isSupplier">
    <div *ngFor="let table of supplierTables; last as isLast">
        <h4 class="montserrat-medium mb-4 text-gray-500">{{ table.title }}</h4>
        <div class="mb-2">Filter by:</div>
        <form name="form" [formGroup]="table.form.value" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange(table.filterValues)" />
                    </mat-form-field>
                </div>
                <div *ngIf="table.multipleStatus != null" class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" (selectionChange)="filterChange(table.filterValues)"
                            panelClass="select-panel-down" [disableOptionCentering]="true">
                            <div *ngFor="let status of table.multipleStatus">
                                <mat-option [value]="status.name" class="text-capitalize">
                                    <span>{{ status.name }}</span>
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div [ngClass]="{
                        'col-12 col-lg-2 mb-4 mb-xl-0': table.multipleStatus != null,
                        'col-12 col-lg-3 mb-4 mb-xl-0': table.multipleStatus == null
                    }">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate"
                            (dateChange)="filterChange(table.filterValues)" />
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div [ngClass]="{
                        'col-12 col-lg-2 mb-4 mb-xl-0': table.multipleStatus != null,
                        'col-12 col-lg-3 mb-4 mb-xl-0': table.multipleStatus == null
                    }">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
                            (dateChange)="filterChange(table.filterValues)" />
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div [ngClass]="{
                        'col-12 col-lg-2 mb-4 mb-xl-0': table.multipleStatus != null,
                        'col-12 col-lg-3 mb-4 mb-xl-0': table.multipleStatus == null
                    }">
                    <button mat-flat-button color="warn" (click)="resetFilters(table.form.value, table.filterValues)">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="table.dataSource.dataSource" class="table" matSort
                        matSortDirection="asc" (matSortChange)="getSupplierCampaigns($event, table.form.name)">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- client_name -->
                        <ng-container matColumnDef="clientName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.issuerName ? element.issuerName : '' }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].realLabel }}
                                    <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                            buildUpcomingStatusMessage(
                                                element.upcomingStatusDate,
                                                element.upcomingStatus,
                                                true
                                            )
                                        " style="
                                            background: transparent;
                                            cursor: pointer;
                                            padding: 4px;
                                        ">
                                        *
                                    </span>
                                    <span *ngIf="
                                            (element.beingEdited &&
                                                isPendingCampaign(element.status)) ||
                                            (element.status == campaignStatus.PAUSED &&
                                                element.beingEdited)
                                        " [matTooltip]="buildInfoMessagePerStatus(element.status)" style="
                                            background: transparent;
                                            cursor: pointer;
                                            padding: 4px;
                                        ">
                                        *
                                    </span></span>
                            </td>
                        </ng-container>

                        <!--Rejection Reason-->
                        <ng-container *ngIf="table.supplierColumns.includes('lastRejectReason')"
                            matColumnDef="lastRejectReason">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Rejection Reason
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.lastRejectReason }}
                            </td>
                        </ng-container>

                        <!-- upcoming_status -->
                        <ng-container *ngIf="table.supplierColumns.includes('upcomingStatus')"
                            matColumnDef="upcomingStatus">
                            <th style="width: 100px !important" mat-header-cell *matHeaderCellDef>
                                Upcoming Status
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span>{{
                                    element.upcomingStatus != null
                                    ? buildUpcomingStatusMessage(
                                    element.upcomingStatusDate,
                                    element.upcomingStatus,
                                    true
                                    )
                                    : ''
                                    }}</span>
                            </td>
                        </ng-container>

                        <!-- price -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <!-- charges -->
                        <ng-container *ngIf="table.supplierColumns.includes('charges')" matColumnDef="charges">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Charges</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element?.totalCharge != 0">{{
                                    element?.totalCharge
                                    | currency: element?.campaignTotalPrice?.currencyCode
                                    }}</span>
                                <span *ngIf="element?.totalCharge == 0"></span>
                            </td>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSource"
                                    (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="table.supplierColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: table.supplierColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons (page)="getSupplierCampaigns($event, table.form.name)"></mat-paginator>
                </div>
            </div>
        </div>
        <div *ngIf="!isLast" class="mt-5 mb-5">
            <hr class="bg-gray-500 mx-4" />
        </div>
    </div>
</div>
<div *ngIf="isAdmin">
    <div>
        <h4 class="montserrat-medium mb-4 text-gray-500">Live and Approved Campaigns</h4>
        <div class="mb-2">Filter by:</div>
        <form name="form" [formGroup]="formLiveApproved" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange('filterValuesLiveApproved')" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePickerLiveApproved" formControlName="startDate"
                            (dateChange)="filterChange('filterValuesLiveApproved')" />
                        <mat-datepicker-toggle matSuffix [for]="startDatePickerLiveApproved"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePickerLiveApproved></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePickerLiveApproved" formControlName="endDate"
                            (dateChange)="filterChange('filterValuesLiveApproved')" />
                        <mat-datepicker-toggle matSuffix [for]="endDatePickerLiveApproved"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePickerLiveApproved></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <button mat-flat-button color="warn"
                        (click)="resetFilters(formLiveApproved, 'filterValuesLiveApproved')">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="dataSourceLiveApproved.dataSource" class="table" matSort
                        matSortDirection="asc" (matSortChange)="getLiveApprovedCampaigns($event)">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- client_name -->
                        <ng-container matColumnDef="clientName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                element.createdByUser.firstName +
                                ' ' +
                                element.createdByUser.lastName
                                }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].realLabel }}
                                    <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                            buildUpcomingStatusMessage(
                                                element.upcomingStatusDate,
                                                element.upcomingStatus
                                            )
                                        " style="background: transparent; cursor: pointer; padding: 4px">
                                        *
                                    </span>
                                </span>
                            </td>
                        </ng-container>

                        <!-- price -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin">
                            <!-- campaign creator -->
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Created by
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdByUser?.email }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSourceLiveApproved"
                                    (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="adminColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: adminColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons
                        (page)="getLiveApprovedCampaigns(liveApprovedSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="mt-5 mb-5">
            <hr class="bg-gray-500 mx-4" />
        </div>

        <h4 class="montserrat-medium mb-4 text-gray-500">Pending Campaigns</h4>
        <div class="mb-2">Filter by:</div>
        <form name="form" [formGroup]="formPending" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange('filterValuesPending')" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePickerPending" formControlName="startDate"
                            (dateChange)="filterChange('filterValuesPending')" />
                        <mat-datepicker-toggle matSuffix [for]="startDatePickerPending"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePickerPending></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePickerPending" formControlName="endDate"
                            (dateChange)="filterChange('filterValuesPending')" />
                        <mat-datepicker-toggle matSuffix [for]="endDatePickerPending"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePickerPending></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <button mat-flat-button color="warn" (click)="resetFilters(formPending, 'filterValuesPending')">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="dataSourcePending.dataSource" class="table" matSort
                        matSortDirection="asc" (matSortChange)="getPendingCampaigns($event)">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- client_name -->
                        <ng-container matColumnDef="clientName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                element.createdByUser.firstName +
                                ' ' +
                                element.createdByUser.lastName
                                }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].realLabel }}
                                    <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                            buildUpcomingStatusMessage(
                                                element.upcomingStatusDate,
                                                element.upcomingStatus
                                            )
                                        " style="background: transparent; cursor: pointer; padding: 4px">
                                        *
                                    </span>
                                </span>
                            </td>
                        </ng-container>

                        <!-- price -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin">
                            <!-- campaign creator -->
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Created by
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdByUser?.email }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSourcePending"
                                    (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="adminColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: adminColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons
                        (page)="getPendingCampaigns(pendingSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="mt-5 mb-5">
            <hr class="bg-gray-500 mx-4" />
        </div>
    </div>
    <div>
        <h4 class="montserrat-medium mb-4 text-gray-500">Paused / Cancelled Campaigns</h4>
        <div class="mt-2 mb-2">Filter by:</div>
        <form name="form" [formGroup]="formPausedCancelled" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange('filterValuesPausedCancelled')" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status"
                            (selectionChange)="filterChange('filterValuesPausedCancelled')"
                            panelClass="select-panel-down" [disableOptionCentering]="true">
                            <mat-option value="PAUSED" class="text-capitalize">
                                <span>PAUSED</span>
                            </mat-option>
                            <mat-option value="CANCELLED" class="text-capitalize">
                                <span>CANCELLED</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePickerPausedCancelled" formControlName="startDate"
                            (dateChange)="filterChange('filterValuesPausedCancelled')" />
                        <mat-datepicker-toggle matSuffix [for]="startDatePickerPausedCancelled"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePickerPausedCancelled></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePickerPausedCancelled" formControlName="endDate"
                            (dateChange)="filterChange('filterValuesPausedCancelled')" />
                        <mat-datepicker-toggle matSuffix [for]="endDatePickerPausedCancelled"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePickerPausedCancelled></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <button mat-flat-button color="warn"
                        (click)="resetFilters(formPausedCancelled, 'filterValuesPausedCancelled')">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="dataSourcePausedCancelled.dataSource" class="table" matSort
                        (matSortChange)="getPausedCancelledCampaigns($event)" matSortDirection="asc">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].label }}
                                    <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                            buildUpcomingStatusMessage(
                                                element.upcomingStatusDate,
                                                element.upcomingStatus
                                            )
                                        " style="background: transparent; cursor: pointer; padding: 4px">
                                        *
                                    </span>
                                    <span *ngIf="element.beingEdited"
                                        [matTooltip]="'This campaign is being edited by the client. You will be notified once the new version is submitted'"
                                        style="background: transparent; cursor: pointer; padding: 4px;">*</span>
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin">
                            <!-- campaign creator -->
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Created by
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdByUser?.email }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element"
                                    [dataSource]="dataSourcePausedCancelled" (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="adminColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: adminColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons
                        (page)="getPausedCancelledCampaigns(pausedCancelledSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="mt-5 mb-5">
            <hr class="bg-gray-500 mx-4" />
        </div>
    </div>
    <div>
        <h4 class="montserrat-medium mb-4 text-gray-500">Completed / Stopped Campaigns</h4>
        <div class="mt-2 mb-2">Filter by:</div>
        <form name="form" [formGroup]="formCancelledStoppedCompleted" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange('filterValuesCancelledStoppedCompleted')" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status"
                            (selectionChange)="filterChange('filterValuesCancelledStoppedCompleted')"
                            panelClass="select-panel-down" [disableOptionCentering]="true">
                            <mat-option value="COMPLETED" class="text-capitalize">
                                <span>COMPLETED</span>
                            </mat-option>
                            <mat-option value="STOPPED" class="text-capitalize">
                                <span>STOPPED</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePickerCancelledStoppedCompleted"
                            formControlName="startDate"
                            (dateChange)="filterChange('filterValuesCancelledStoppedCompleted')" />
                        <mat-datepicker-toggle matSuffix
                            [for]="startDatePickerCancelledStoppedCompleted"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePickerCancelledStoppedCompleted></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePickerCancelledStoppedCompleted"
                            formControlName="endDate"
                            (dateChange)="filterChange('filterValuesCancelledStoppedCompleted')" />
                        <mat-datepicker-toggle matSuffix
                            [for]="endDatePickerCancelledStoppedCompleted"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePickerCancelledStoppedCompleted></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-2 mb-4 mb-xl-0">
                    <button mat-flat-button color="warn"
                        (click)="resetFilters(formCancelledStoppedCompleted, 'filterValuesCancelledStoppedCompleted')">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="dataSourceCancelledStoppedCompleted.dataSource" class="table" matSort
                        (matSortChange)="getCancelledStoppedCompletedCampaigns($event)" matSortDirection="asc">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].label }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin">
                            <!-- campaign creator -->
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Created by
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdByUser?.email }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element"
                                    [dataSource]="dataSourceCancelledStoppedCompleted"
                                    (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="adminColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: adminColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons
                        (page)="getCancelledStoppedCompletedCampaigns(cancelledStoppedCompletedSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="mt-5 mb-5">
            <hr class="bg-gray-500 mx-4" />
        </div>
        <div>
            <h4 class="montserrat-medium mb-4 text-gray-500">Rejected Campaigns</h4>
            <div class="mb-2">Filter by:</div>
            <form name="form" [formGroup]="formRejected" class="mb-4">
                <div class="row">
                    <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                        <mat-form-field class="form-group dark-input">
                            <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                                (input)="filterChange('filterValuesRejected')" />
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                        <mat-form-field class="form-group dark-input">
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="startDatePickerRejected" formControlName="startDate"
                                (dateChange)="filterChange('filterValuesRejected')" />
                            <mat-datepicker-toggle matSuffix [for]="startDatePickerRejected"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePickerRejected></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                        <mat-form-field class="form-group dark-input">
                            <mat-label>End Date</mat-label>
                            <input matInput [matDatepicker]="endDatePickerRejected" formControlName="endDate"
                                (dateChange)="filterChange('filterValuesRejected')" />
                            <mat-datepicker-toggle matSuffix [for]="endDatePickerRejected"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePickerRejected></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                        <button mat-flat-button color="warn"
                            (click)="resetFilters(formRejected, 'filterValuesRejected')">
                            Reset
                        </button>
                    </div>
                </div>
            </form>
            <div>
                <div class="mat-elevation-z8">
                    <div class="tableHolder table-responsive">
                        <table mat-table [dataSource]="dataSourceRejected.dataSource" class="table" matSort
                            matSortDirection="asc" (matSortChange)="getRejectedCampaigns($event)">
                            <!-- campaign_name -->
                            <ng-container matColumnDef="title">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Campaign Name
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.title }}
                                </td>
                            </ng-container>

                            <!-- client_name -->
                            <ng-container matColumnDef="clientName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Client Name
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{
                                    element.createdByUser.firstName +
                                    ' ' +
                                    element.createdByUser.lastName
                                    }}
                                </td>
                            </ng-container>

                            <!-- start_date -->
                            <ng-container matColumnDef="startDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Start Date
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.startDate | date: 'medium' }}
                                </td>
                            </ng-container>

                            <!-- end_date -->
                            <ng-container matColumnDef="endDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.endDate | date: 'medium' }}
                                </td>
                            </ng-container>

                            <!-- status -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                            'background-color': this.status[element.status].color
                                        }">{{ this.status[element.status].realLabel }}</span>
                                </td>
                            </ng-container>

                            <!-- price -->
                            <ng-container matColumnDef="price">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element.campaignTotalPrice != null">{{
                                        element.campaignTotalPrice.value
                                        | currency: element.campaignTotalPrice.currencyCode
                                        }}</span>
                                    <span *ngIf="element.campaignTotalPrice == null">0</span>
                                </td>
                            </ng-container>

                            <!--Rejection Reason-->
                            <ng-container matColumnDef="lastRejectReason">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Rejection Reason
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.lastRejectReason }}
                                </td>
                            </ng-container>

                            <ng-container *ngIf="isAdmin">
                                <!-- campaign creator -->
                                <ng-container matColumnDef="createdBy">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Created by
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.createdByUser?.email }}
                                    </td>
                                </ng-container>
                            </ng-container>

                            <!-- actions -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>Actions</th>
                                <td mat-cell *matCellDef="let element">
                                    <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSourceRejected"
                                        (onTriggerAction)="handleAction($event)">
                                    </app-campaign-action-buttons>
                                </td>
                            </ng-container>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9999" style="text-align: center">
                                    No data matching the filter
                                </td>
                            </tr>

                            <tr mat-header-row *matHeaderRowDef="adminRejectedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: adminRejectedColumns"
                                [class.unseen-update]="row.hasUnseenUpdates && !isAdmin && !isSupplier"></tr>
                        </table>
                        <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                            showFirstLastButtons
                            (page)="getRejectedCampaigns(rejectedSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="mt-5 mb-5">
                <hr class="bg-gray-500 mx-4" />
            </div>
        </div>
    </div>
    <div>
        <h4 class="montserrat-medium mb-4 text-gray-500">Draft Campaigns</h4>
        <div class="mb-2">Filter by:</div>
        <form name="form" [formGroup]="formDraft" class="mb-4">
            <div class="row">
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <input matInput formControlName="search" type="text" placeholder="Campaign Name"
                            (input)="filterChange('filterValuesDraft')" />
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePickerDraft" formControlName="startDate"
                            (dateChange)="filterChange('filterValuesDraft')" />
                        <mat-datepicker-toggle matSuffix [for]="startDatePickerDraft"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePickerDraft></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <mat-form-field class="form-group dark-input">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePickerDraft" formControlName="endDate"
                            (dateChange)="filterChange('filterValuesDraft')" />
                        <mat-datepicker-toggle matSuffix [for]="endDatePickerDraft"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePickerDraft></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-3 mb-4 mb-xl-0">
                    <button mat-flat-button color="warn" (click)="resetFilters(formDraft, 'filterValuesDraft')">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <div>
            <div class="mat-elevation-z8">
                <div class="tableHolder table-responsive">
                    <table mat-table [dataSource]="dataSourceDraft.dataSource" class="table" matSort
                        matSortDirection="asc" (matSortChange)="getDraftCampaigns($event)">
                        <!-- campaign_name -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.title }}
                            </td>
                        </ng-container>

                        <!-- client_name -->
                        <ng-container matColumnDef="clientName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                element.createdByUser.firstName +
                                ' ' +
                                element.createdByUser.lastName
                                }}
                            </td>
                        </ng-container>

                        <!-- start_date -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.startDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- end_date -->
                        <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.endDate | date: 'medium' }}
                            </td>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge br-20 d-block text-white px-3 py-2 text-center" [style]="{
                                        'background-color': this.status[element.status].color
                                    }">{{ this.status[element.status].realLabel }}
                                    <span *ngIf="element.upcomingStatusDate && element.upcomingStatus" [matTooltip]="
                                            buildUpcomingStatusMessage(
                                                element.upcomingStatusDate,
                                                element.upcomingStatus
                                            )
                                        " style="background: transparent; cursor: pointer; padding: 4px">
                                        *
                                    </span>
                                </span>
                            </td>
                        </ng-container>

                        <!-- price -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.campaignTotalPrice != null">{{
                                    element.campaignTotalPrice.value
                                    | currency: element.campaignTotalPrice.currencyCode
                                    }}</span>
                                <span *ngIf="element.campaignTotalPrice == null">0</span>
                            </td>
                        </ng-container>

                        <ng-container *ngIf="isAdmin">
                            <!-- campaign creator -->
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Created by
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdByUser?.email }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <!-- actions -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <app-campaign-action-buttons [campaign]="element" [dataSource]="dataSourceDraft"
                                    (onTriggerAction)="handleAction($event)">
                                </app-campaign-action-buttons>
                            </td>
                        </ng-container>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9999" style="text-align: center">
                                No data matching the filter
                            </td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="adminColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: adminColumns"></tr>
                    </table>
                    <mat-paginator [length]="paginator.length" [pageSizeOptions]="[20, 50, 100]" pageSize="20"
                        showFirstLastButtons
                        (page)="getCancelledStoppedCompletedCampaigns(cancelledStoppedCompletedSort, $event.pageIndex, $event.pageSize)"></mat-paginator>
                </div>
            </div>
        </div>
        <div>
            <div class="mt-5 mb-5">
                <hr class="bg-gray-500 mx-4" />
            </div>
        </div>
    </div>
</div>